export default "__VITE_ASSET__BY9PcCp4__"